export default {
  namespaced: true,
  state: {
    sellCard: []
  },
  getters: {},
  mutations: {
    setSellCard(state, b) {
      state.sellCard = b
    }
  },
  actions: {}
}
